import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=24a47a37&scoped=true&"
import script from "./ChangePwd.vue?vue&type=script&lang=js&"
export * from "./ChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=24a47a37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a47a37",
  null
  
)

export default component.exports